import React from 'react';

import { useGraphQLMutation } from '@betterment/graphql';
import { Box, Button, Dialog, H1, Text } from '@betterment/samba-react';
import * as Sentry from '@sentry/browser';

import { UpdateFirmIntegrationSubscriptionStatusDocument } from './graphql/mutation.firmSubscription.generated';

import { OutboundIntegration } from '../../graphql/schema';

const IntegrationDisconnectModal: React.FC<{
  saveHandler: () => void;
  integration: OutboundIntegration;
}> = ({ saveHandler, integration }) => {
  const [subscribeFirm, { loading }] = useGraphQLMutation(UpdateFirmIntegrationSubscriptionStatusDocument);

  return (
    <Dialog.Content size="medium" css={{ p: 'space.400' }}>
      <Dialog.Title asChild={true}>
        <H1 variant="title300" css={{ pb: 'space.150' }}>
          Disconnect from {integration.name}?
        </H1>
      </Dialog.Title>
      <Dialog.Description asChild={true}>
        <Text color="text" variant="text100">
          Once disconnected, we will stop sending data to {integration.name}.
        </Text>
      </Dialog.Description>
      <Box css={{ display: 'flex', mt: 'space.400' }}>
        <Button
          css={{
            mr: 'space.100',
            background: 'background.critical.strong',
            '&:hover': { background: 'background.critical.strong.active' },
          }}
          onClick={() => {
            subscribeFirm({
              variables: {
                input: {
                  id: integration.id,
                  isSubscribed: false,
                },
              },
            })
              .then(() => {
                saveHandler();
              })
              .catch(err => {
                Sentry.captureException(err);
              });
          }}
          variant="solidPrimary"
          loading={loading}
        >
          Disconnect
        </Button>
        <Dialog.Close asChild={true}>
          <Button variant="solidSecondary">Cancel</Button>
        </Dialog.Close>
      </Box>
    </Dialog.Content>
  );
};

export default IntegrationDisconnectModal;
